export const APP_LIFECYCLE_SLICE_NAME = 'appLifecycle';

export interface AppLifecycleSliceState {
  isAppInitialized: boolean;
}
